let projects = [{
    type:1,
    name:'固有项目',
    children:[{
        name:'一般检查',
        des:'身高,体重,体重指数,收缩压,舒张压'
    },{
        name:'内科',
        des:'病史,家族史,心率,心律,心音,肺部听诊,肝脏触诊,脾脏触诊,肾脏叩诊,内科其它'
    },{
        name:'外科',
        des:'通过体格检查,检查皮肤、甲状腺、脊柱四肢、前列腺(男外科)等重要脏器基本情况,发现常见外科疾病的相关征兆,或初步排除外科常见疾病'
    },{
        name:'视力色觉、耳鼻咽喉科',
        des:'裸视力(右),裸视力(左),矫正视力(右),矫正视力(左),色觉既往史,外耳,外耳道,鼓膜,鼻腔,鼻中隔,咽,扁桃体,耳鼻咽喉科其它'
    },{
        name:'血常规、尿常规',
        des:'通过血常规检查发现血液方面的问题,评价骨髓功能;用于检查泌尿系统疾病,协助检查其他系统疾病'
    },{
        name:'肝功二项',
        des:'丙氨酸氨基转移酶,天门冬氨酸氨基转移酶'
    },{
        name:'肾功三项',
        des:'尿素,肌酐,尿酸'
    },{
        name:'空腹血糖',
        des:'空腹血葡萄糖'
    },{
        name:'心电图',
        des:'通过在体表特定部位同步记录和分析心脏每一个心动周期所产生电活动变化的曲线图形'
    }]
},{
    type:2,
    name:'五官科检测',
    children:[{
        name:'非接触性眼压测量',
        des:'左眼非接触性眼压,右眼非接触性眼压',
        price:'21',
        vipPrice:'26'
    },{
        name:'裂隙灯检查',
        des:'检查巩膜、虹膜、角膜、瞳孔、玻璃体等',
        price:'16',
        vipPrice:'20'
    },{
        name:'眼底镜检查',
        des:'检查眼底视网膜、视神经乳头和视网膜中央血管等',
        price:'16',
        vipPrice:'20'
    },{
        name:'听力(音叉)',
        des:'以128HZ音叉检测听力',
        price:'5',
        vipPrice:'7'
    },{
        name:'口腔科',
        des:'口腔常规检查,全面了解口腔健康状况',
        price:'26',
        vipPrice:'33'
    }]
},{
    type:3,
    name:'女性妇科专项检测',
    children:[{
        name:'妇科检查',
        des:'通过妇科触诊及仪器检查方法,发现常见妇科疾病的相关征兆,或初步排除妇科常见疾病',
        price:'26',
        vipPrice:'33'
    },{
        name:'白带常规',
        des:'白带清洁度,念珠样菌,滴虫,其它(白带)',
        price:'16',
        vipPrice:'20'
    },{
        name:'宫颈刮片',
        des:'子宫颈脱落细胞的巴氏染色检查',
        price:'53',
        vipPrice:'65'
    },{
        name:'宫颈TCT',
        des:'液基薄层细胞学检查',
        price:'189',
        vipPrice:'234'
    },{
        name:'人乳头瘤病毒分型(HPV分型)',
        des:'反映人体内乳头瘤病毒是否存在,具体判断感染型别',
        price:'368',
        vipPrice:'455'
    },{
        name:'性激素五项',
        des:'孕酮,雌二醇,卵泡刺激素,促黄体生成激素,睾酮',
        price:'473',
        vipPrice:'585'
    },{
        name:'性激素六项',
        des:'孕酮,雌二醇,卵泡刺激素,促黄体生成激素,睾酮,泌乳素',
        price:'576',
        vipPrice:'702'
    },{
        name:'孕酮(P)',
        des:'孕酮',
        price:'95',
        vipPrice:'117'
    },{
        name:'雌二醇(E2)',
        des:'雌二醇',
        price:'95',
        vipPrice:'117'
    },{
        name:'促黄体生成激素(LH)',
        des:'促黄体生成激素',
        price:'95',
        vipPrice:'117'
    },{
        name:'卵泡刺激素(FSH)',
        des:'卵泡刺激素',
        price:'95',
        vipPrice:'117'
    },{
        name:'睾酮(T)',
        des:'睾酮',
        price:'95',
        vipPrice:'117'
    },{
        name:'泌乳素(PRL)',
        des:'泌乳素',
        price:'95',
        vipPrice:'117'
    },{
        name:'优生优育检测五项',
        des:'风疹病毒抗体IgM,弓形虫抗体IgM,巨细胞病毒抗体IgM,单纯疱疹病毒Ⅰ抗体IgM,单纯疱疹病毒Ⅱ抗体IgM',
        price:'368',
        vipPrice:'455'
    },{
        name:'优生优育检测十项',
        des:'风疹病毒抗体IgG,风疹病毒抗体IgM,弓形虫抗体IgG,弓形虫抗体IgM,巨细胞病毒抗体IgG,巨细胞病毒抗体IgM,单纯疱疹病毒Ⅰ抗体IgG,单纯疱疹病毒Ⅰ抗体IgM,单纯疱疹病毒Ⅱ抗体IgG,单纯疱疹病毒Ⅱ抗体IgM',
        price:'735',
        vipPrice:'910'
    }]
},{
    type:4,
    name:'肝肾功能检测',
    children:[{
        name:'肝功十一项',
        des:'丙氨酸氨基转移酶,天门冬氨酸氨基转移酶,γ-谷氨酰转移酶,碱性磷酸酶,总胆红素,直接胆红素,间接胆红素,总蛋白,白蛋白,球蛋白,白蛋白/球蛋白比值',
        price:'116',
        vipPrice:'143'
    },{
        name:'肝功十三项',
        des:'丙氨酸氨基转移酶,天门冬氨酸氨基转移酶,γ-谷氨酰转移酶,碱性磷酸酶,总胆汁酸,胆碱酯酶,总胆红素,直接胆红素,间接胆红素,总蛋白,白蛋白,球蛋白,白蛋白/球蛋白比值',
        price:'168',
        vipPrice:'208'
    },{
        name:'γ- 谷氨酰转移酶(GGT)',
        des:'γ-谷氨酰转移酶',
        price:'16',
        vipPrice:'20'
    },{
        name:'碱性磷酸酶(ALP)',
        des:'碱性磷酸酶',
        price:'16',
        vipPrice:'20'
    },{
        name:'总胆汁酸(TBA)',
        des:'总胆汁酸',
        price:'32',
        vipPrice:'39'
    },{
        name:'胆碱酯酶(CHE)',
        des:'胆碱酯酶',
        price:'21',
        vipPrice:'26'
    },{
        name:'胆红素三项',
        des:'总胆红素,直接胆红素,间接胆红素',
        price:'42',
        vipPrice:'52'
    },{
        name:'血清蛋白四项',
        des:'总蛋白,白蛋白,球蛋白,白蛋白/球蛋白比值',
        price:'21',
        vipPrice:'26'
    },{
        name:'β2微球蛋白',
        des:'β2微球蛋白',
        price:'85',
        vipPrice:'105'
    },{
        name:'血清胱抑素',
        des:'血清胱抑素c',
        price:'68',
        vipPrice:'85'
    }]
},{
    type:5,
    name:'心脑血管疾病筛查项目',
    children:[{
        name:'餐后2小时血糖',
        des:'餐后2小时血葡萄糖',
        price:'21',
        vipPrice:'26'
    },{
        name:'糖化血红蛋白(HbA1c)',
        des:'检测HbA1c对高血糖、尤在血糖和尿糖波动较大时有特殊诊断意义',
        price:'105',
        vipPrice:'130'
    },{
        name:'胰岛素(INS)',
        des:'用于糖尿病分型诊断及低血糖的诊断和鉴别诊断',
        price:'95',
        vipPrice:'117'
    },{
        name:'C-肽(C-P)',
        des:'评价胰岛B细胞分泌、储备功能',
        price:'95',
        vipPrice:'117'
    },{
        name:'血脂二项',
        des:'总胆固醇,甘油三酯',
        price:'32',
        vipPrice:'39'
    },{
        name:'血脂四项',
        des:'总胆固醇,甘油三酯,高密度脂蛋白胆固醇,低密度脂蛋白胆固醇',
        price:'84',
        vipPrice:'104'
    },{
        name:'血脂七项',
        des:'总胆固醇,甘油三酯,高密度脂蛋白胆固醇,低密度脂蛋白胆固醇,载脂蛋白A1,载脂蛋白B,脂蛋白(a)',
        price:'315',
        vipPrice:'390'
    },{
        name:'总胆固醇(TC)',
        des:'总胆固醇',
        price:'16',
        vipPrice:'20'
    },{
        name:'甘油三酯(TG)',
        des:'甘油三酯',
        price:'16',
        vipPrice:'20'
    },{
        name:'高密度脂蛋白胆固醇(HDL-C)',
        des:'高密度脂蛋白胆固醇',
        price:'26',
        vipPrice:'33'
    },{
        name:'低密度脂蛋白胆固醇(LDL-C)',
        des:'低密度脂蛋白胆固醇',
        price:'26',
        vipPrice:'33'
    },{
        name:'载脂蛋白A1(Apo-A1)',
        des:'载脂蛋白A1',
        price:'63',
        vipPrice:'78'
    },{
        name:'载脂蛋白B(Apo-B)',
        des:'载脂蛋白B',
        price:'63',
        vipPrice:'78'
    },{
        name:'脂蛋白(a)(LP(a))',
        des:'脂蛋白(a)',
        price:'105',
        vipPrice:'130'
    },{
        name:'心肌酶三项',
        des:'磷酸肌酸激酶,磷酸肌酸激酶同工酶,乳酸脱氢酶',
        price:'68',
        vipPrice:'85'
    },{
        name:'磷酸肌酸激酶(CK)',
        des:'磷酸肌酸激酶',
        price:'26',
        vipPrice:'33'
    },{
        name:'磷酸肌酸激酶同工酶(CK-MB)',
        des:'磷酸肌酸激酶同工酶',
        price:'26',
        vipPrice:'33'
    },{
        name:'乳酸脱氢酶(LDH)',
        des:'乳酸脱氢酶',
        price:'16',
        vipPrice:'20'
    },{
        name:'α-羟丁酸脱氢酶(α-HBD)',
        des:'主要存在于心肌,在心肌受损时释放入血',
        price:'32',
        vipPrice:'39'
    },{
        name:'同型半胱氨酸',
        des:'高浓度同型半胱氨酸血症是动脉硬化的独立危险因素',
        price:'221',
        vipPrice:'273'
    },{
        name:'电解质三项',
        des:'血清钙,血清磷,血清镁',
        price:'32',
        vipPrice:'39'
    },{
        name:'血清镁',
        des:'血清镁',
        price:'11',
        vipPrice:'13'
    },{
        name:'血清钙',
        des:'血清钙',
        price:'11',
        vipPrice:'13'
    },{
        name:'血清磷',
        des:'血清磷',
        price:'11',
        vipPrice:'13'
    },{
        name:'血清钾',
        des:'血清钾',
        price:'11',
        vipPrice:'13'
    },{
        name:'血清钠',
        des:'血清钠',
        price:'11',
        vipPrice:'13'
    },{
        name:'血清氯',
        des:'血清氯',
        price:'11',
        vipPrice:'13'
    },{
        name:'血沉(ESR)',
        des:'红细胞沉降率',
        price:'32',
        vipPrice:'39'
    },{
        name:'血流变',
        des:'全血粘度1,全血粘度5,全血粘度30,全血粘度200,血浆粘度,血沉,压积,全血高切相对指数,全血低切相对指数,血沉方程K值,红细胞聚集指数,全血低切还原粘度,全血高切还原粘度,红细胞刚性指数,红细胞变形指数',
        price:'105',
        vipPrice:'130'
    },{
        name:'经颅多普勒检查',
        des:'了解颅内及颅外各血管、脑动脉环血管及其分支的血流情况',
        price:'273',
        vipPrice:'338'
    },{
        name:'动脉硬化检测',
        des:'对人体动脉血管做总体性评估,便于早发现动脉硬化',
        price:'189',
        vipPrice:'234'
    },{
        name:'骨密度检查',
        des:'通过骨密度仪检查骨质密度',
        price:'126',
        vipPrice:'156'
    }]
},{
    type:6,
    name:'胃肠疾病筛查项目',
    children:[{
        name:'便隐血',
        des:'检查粪便中隐藏的红细胞或血红蛋白的一项实验',
        price:'11',
        vipPrice:'13'
    },{
        name:'便常规',
        des:'便颜色,便性状,便红细胞,便白细胞,便虫卵,便常规其它',
        price:'11',
        vipPrice:'13'
    },{
        name:'幽门螺杆菌抗体(Hp-Ab)',
        des:'幽门螺杆菌抗体阳性提示既往感染过或正在感染幽门螺杆菌',
        price:'95',
        vipPrice:'117'
    },{
        name:'幽门螺杆菌检测(C14呼气试验)',
        des:'幽门螺杆菌检测(呼气试验)',
        price:'180',
        vipPrice:'216'
    },{
        name:'幽门螺杆菌检测(C13呼气试验)',
        des:'幽门螺杆菌检测(呼气试验)',
        price:'347',
        vipPrice:'416'
    },{
        name:'胃泌素测定(G-17)',
        des:'对胃窦部炎症具有更高的检测灵敏度',
        price:'160',
        vipPrice:'192'
    },{
        name:'卫长卫',
        des:'人半胱氨酸蛋白酶抑制剂S(CST4)',
        price:'480',
        vipPrice:'575'
    }]
},{
    type:'7',
    name:'病毒检测',
    children:[{
        name:'乙肝表面抗原(HBsAg)',
        des:'乙型肝炎病毒表面抗原',
        price:'16',
        vipPrice:'20'
    },
    // {
    //     name:'乙肝五项定性测定',
    //     des:'乙型肝炎病毒表面抗原,乙型肝炎病毒表面抗体,乙型肝炎病毒e抗原,乙型肝炎病毒e抗体,乙型肝炎病毒核心抗体',
    //     price:'74',
    //     vipPrice:'91'
    // },
    {
        name:'乙肝五项定量测定',
        des:'乙型肝炎病毒表面抗原定量,乙型肝炎病毒表面抗体定量,乙型肝炎病毒e抗原定量,乙型肝炎病毒e抗体定量,乙型肝炎病毒核心抗体定量',
        price:'315',
        vipPrice:'390'
    },{
        name:'乙型肝炎病毒DNA定量(HBV-DNA)',
        des:'乙型肝炎病毒DNA',
        price:'189',
        vipPrice:'234'
    },{
        name:'甲型肝炎病毒抗体IgM(HAV-IgM)',
        des:'甲型肝炎病毒抗体-IgM',
        price:'53',
        vipPrice:'65'
    },{
        name:'丙肝病毒抗体(HCV-Ab)',
        des:'丙型肝炎病毒抗体',
        price:'105',
        vipPrice:'130'
    },{
        name:'丁型肝炎病毒IgG抗体(HDV-IgG)',
        des:'丁型肝炎病毒抗体IgG',
        price:'42',
        vipPrice:'52'
    },{
        name:'戊型肝炎病毒IgG抗体 (HEV-IgG)',
        des:'戊型肝炎病毒抗体IgG',
        price:'84',
        vipPrice:'104'
    },{
        name:'EB病毒壳抗原-IgA抗体(EB-VCA-IgA)',
        des:'临床辅助诊断鼻咽癌',
        price:'84',
        vipPrice:'104'
    },{
        name:'免疫球蛋白A(IgA)',
        des:'免疫球蛋白A',
        price:'42',
        vipPrice:'52'
    },{
        name:'免疫球蛋白G(IgG)',
        des:'免疫球蛋白G',
        price:'42',
        vipPrice:'52'
    },{
        name:'免疫球蛋白M(IgM)',
        des:'免疫球蛋白M',
        price:'42',
        vipPrice:'52'
    },{
        name:'免疫球蛋白E(IgE)',
        des:'免疫球蛋白E',
        price:'95',
        vipPrice:'117'
    },{
        name:'补体C3',
        des:'辅助诊断免疫系统疾病',
        price:'95',
        vipPrice:'117'
    },{
        name:'补体C4',
        des:'辅助诊断免疫系统疾病',
        price:'95',
        vipPrice:'117'
    },{
        name:'结核杆菌抗体(TB-Ab)',
        des:'结核杆菌抗体',
        price:'63',
        vipPrice:'78'
    },{
        name:'艾滋病抗体(HIV-Ab)',
        des:'艾滋病抗体',
        price:'105',
        vipPrice:'130'
    },
    // {
    //     name:'梅毒螺旋体抗体初筛(Anti-TP)',
    //     des:'梅毒螺旋体抗体初筛(Anti-TP)',
    //     price:'63',
    //     vipPrice:'78'
    // },
    {
        name:'类风湿因子(RF)',
        des:'类风湿因子',
        price:'63',
        vipPrice:'78'
    },{
        name:'抗链球菌溶血素"O"(ASO)',
        des:'作为链球菌感染后变态反应性疾病(风湿热、肾小球肾炎等)的辅助诊断',
        price:'63',
        vipPrice:'78'
    },{
        name:'超敏C反应蛋白(HS-CRP)',
        des:'对心血管疾病的风险预测有重要意义',
        price:'95',
        vipPrice:'117'
    }]
},{
    type:'8',
    name:'肿瘤标志物检测',
    children:[{
        name:'癌胚抗原定量(CEA)',
        des:'系广谱性肿瘤标志物',
        price:'63',
        vipPrice:'78'
    },{
        name:'甲胎蛋白定量(AFP)',
        des:'对原发性肝癌的诊断、疗效观察和预后评估有重要的临床意义',
        price:'63',
        vipPrice:'78'
    },{
        name:'总前列腺特异性抗原 (T-PSA)',
        des:'对男性前列腺癌的诊断、疗效观察、评估预后有重要临床意义',
        price:'126',
        vipPrice:'156'
    },{
        name:'前列腺肿瘤标志物组合',
        des:'总前列腺特异性抗原,游离前列腺特异性抗原,F-PSA/T-PSA',
        price:'252',
        vipPrice:'312'
    },{
        name:'癌抗原19-9(CA19-9)',
        des:'对胰腺癌、胆道肿瘤、胃肠癌等的筛查及疗效监测、评估预后有临床重要意义',
        price:'126',
        vipPrice:'156'
    },{
        name:'癌抗原242(CA242)',
        des:'对胰腺癌、结肠、胃、卵巢、子宫、肺癌的筛查有临床重要意义',
        price:'126',
        vipPrice:'156'
    },{
        name:'神经元特异性烯醇化酶(NSE)',
        des:'对小细胞肺癌、神经母细胞瘤的早期诊断及评估预后',
        price:'126',
        vipPrice:'156'
    },{
        name:'细胞角蛋白',
        des:'对肺癌的早期诊断及评估预后',
        price:'126',
        vipPrice:'156'
    },{
        name:'癌抗原724(CA-724)',
        des:'用于卵巢、大肠、胰腺、胃、乳腺癌的筛查',
        price:'126',
        vipPrice:'156'
    },{
        name:'癌抗原15-3(CA15-3)',
        des:'乳腺癌时可明显升高',
        price:'126',
        vipPrice:'156'
    },{
        name:'癌抗原125(CA125)',
        des:'增高见于妇科及消化道恶性肿瘤',
        price:'126',
        vipPrice:'156'
    },{
        name:'癌抗原50(CA50)',
        des:'广谱肿瘤标志物',
        price:'126',
        vipPrice:'156'
    },{
        name:'胃蛋白酶原二项(Ⅰ及Ⅱ)',
        des:'胃蛋白酶原Ⅰ,胃蛋白酶原Ⅱ,PGI/PGII',
        price:'252',
        vipPrice:'312'
    },{
        name:'鳞状上皮细胞癌抗原(SCC)',
        des:'鳞状上皮细胞癌相关抗原',
        price:'126',
        vipPrice:'156'
    },{
        name:'人绒毛膜促性腺激素游离β亚基(Free-β-hCG)',
        des:'对早期妊娠诊断有重要意义,对与妊娠相关疾病、滋养细胞肿瘤等疾病的筛查等有一定价值。',
        price:'95',
        vipPrice:'117'
    }
    // ,{
    //     name:'TM-12(男性)',
    //     des:'F-PSA/T-PSA,PGI/PGII,癌胚抗原,甲胎蛋白,神经元特异性烯醇化酶,糖类抗原125,糖类抗原19-9,糖类抗原242,细胞角蛋白19片段,游离前列腺特异性抗原,总前列腺特异性抗原,人绒毛膜促性腺激素游离β亚基,胃蛋白酶原Ⅰ,胃蛋白酶原Ⅱ',
    //     price:'800',
    //     vipPrice:'960'
    // },{
    //     name:'TM-12(女性)',
    //     des:'PGI/PGII,癌胚抗原,甲胎蛋白,神经元特异性烯醇化酶,糖类抗原125,糖类抗原15-3,糖类抗原19-9,糖类抗原242,细胞角蛋白19片段,鳞状上皮细胞癌相关抗原,人绒毛膜促性腺激素游离β亚基,胃蛋白酶原Ⅰ,胃蛋白酶原Ⅱ',
    //     price:'800',
    //     vipPrice:'960'
    // }
    ,{
        name:'人纤维蛋白原降解产物(DR-70)',
        des:'一组与恶性肿瘤密切相关蛋白质',
        price:'221',
        vipPrice:'273'
    }]
},{
    type:'9',
    name:'甲状腺功能检测',
    children:[{
        name:'甲功三项A',
        des:'游离三碘甲状原氨酸,游离甲状腺素,促甲状腺激素',
        price:'189',
        vipPrice:'234'
    },{
        name:'甲功三项B',
        des:'三碘甲状腺原氨酸,甲状腺素,促甲状腺激素',
        price:'189',
        vipPrice:'234'
    },{
        name:'甲功五项',
        des:'三碘甲状腺原氨酸,游离三碘甲状原氨酸,甲状腺素,游离甲状腺素,促甲状腺激素',
        price:'315',
        vipPrice:'390'
    },{
        name:'三碘甲状腺原氨酸(T3)',
        des:'三碘甲状腺原氨酸',
        price:'63',
        vipPrice:'78'
    },{
        name:'甲状腺素(T4)',
        des:'甲状腺素',
        price:'63',
        vipPrice:'78'
    },{
        name:'促甲状腺激素(TSH)',
        des:'促甲状腺激素',
        price:'63',
        vipPrice:'78'
    },{
        name:'游离三碘甲状原氨酸(FT3)',
        des:'游离三碘甲状原氨酸',
        price:'63',
        vipPrice:'78'
    },{
        name:'游离甲状腺素(FT4)',
        des:'游离甲状腺素',
        price:'63',
        vipPrice:'78'
    },{
        name:'抗甲状腺球蛋白抗体(TG-Ab)',
        des:'抗甲状腺球蛋白抗体',
        price:'84',
        vipPrice:'104'
    },{
        name:'抗甲状腺微粒体抗体(TM-Ab)',
        des:'抗甲状腺微粒体抗体',
        price:'84',
        vipPrice:'104'
    }]
},{
    type:'10',
    name:'营养检测',
    children:[{
        name:'微量元素铅',
        des:'铅',
        price:'100',
        vipPrice:'124'
    },{
        name:'微量元素五项',
        des:'铁,钙,铜,锌,镁',
        price:'79',
        vipPrice:'98'
    },{
        name:'微量元素六项',
        des:'铁,钙,铜,锌,镁,铅',
        price:'179',
        vipPrice:'221'
    }]
},{
    type:'11',
    name:'彩超检测',
    children:[{
        name:'腹部彩超',
        des:'肝,胆,胰,脾,双肾',
        price:'105',
        vipPrice:'130'
    },{
        name:'前列腺彩超',
        des:'前列腺',
        price:'105',
        vipPrice:'130'
    },{
        name:'子宫、附件彩超',
        des:'子宫,附件',
        price:'105',
        vipPrice:'130'
    },{
        name:'阴式彩超',
        des:'子宫,附件',
        price:'105',
        vipPrice:'130'
    },{
        name:'乳腺彩超',
        des:'乳腺',
        price:'126',
        vipPrice:'156'
    },{
        name:'甲状腺彩超',
        des:'甲状腺',
        price:'126',
        vipPrice:'156'
    },{
        name:'颈动脉彩超',
        des:'颈动脉',
        price:'126',
        vipPrice:'156'
    },{
        name:'心脏彩超',
        des:'心脏',
        price:'294',
        vipPrice:'364'
    },{
        name:'膀胱彩超',
        des:'膀胱',
        price:'105',
        vipPrice:'130'
    },{
        name:'输尿管彩超',
        des:'输尿管',
        price:'105',
        vipPrice:'130'
    }]
},{
    type:'12',
    name:'DR影像',
    children:[{
        name:'胸部正位',
        des:'胸部',
        price:'74',
        vipPrice:'91'
    },{
        name:'胸部正侧位',
        des:'胸部',
        price:'147',
        vipPrice:'182'
    },{
        name:'颈椎侧位',
        des:'颈部',
        price:'53',
        vipPrice:'65'
    },{
        name:'颈椎正侧位',
        des:'颈部',
        price:'105',
        vipPrice:'130'
    },{
        name:'颈椎双斜位',
        des:'颈部',
        price:'105',
        vipPrice:'130'
    },{
        name:'颈椎正侧双斜位',
        des:'颈部',
        price:'210',
        vipPrice:'280'
    },{
        name:'腰椎正侧位',
        des:'腰椎',
        price:'147',
        vipPrice:'182'
    },{
        name:'左侧肩关节正位',
        des:'肩关节',
        price:'53',
        vipPrice:'65'
    },{
        name:'右侧肩关节正位',
        des:'肩关节',
        price:'53',
        vipPrice:'65'
    },{
        name:'左侧肘关节正侧位',
        des:'肘关节',
        price:'105',
        vipPrice:'130'
    },{
        name:'右侧肘关节正侧位',
        des:'肘关节',
        price:'105',
        vipPrice:'130'
    },{
        name:'左侧腕关节正侧位',
        des:'腕关节',
        price:'105',
        vipPrice:'130'
    },{
        name:'右侧腕关节正侧位',
        des:'腕关节',
        price:'105',
        vipPrice:'130'
    },{
        name:'左侧膝关节正侧位',
        des:'膝关节',
        price:'105',
        vipPrice:'130'
    }]
},{
    type:'13',
    name:'CT影像',
    children:[{
        name:'胸部',
        des:'',
        price:'',
        vipPrice:''
    },{
        name:'头颅',
        des:'',
        price:'',
        vipPrice:''
    },{
        name:'颈椎',
        des:'',
        price:'',
        vipPrice:''
    },{
        name:'腰椎',
        des:'',
        price:'',
        vipPrice:''
    }]
}]

export default projects